import { useQuery } from "@tanstack/react-query";
import axiosPrivate from "../axiosPrivate";

export const useWallet = () =>
  useQuery({
    queryKey: ["customerWallets"],
    queryFn: async () => {
      const res = await axiosPrivate.get("customers/wallets");
      return res.data;
    },
    refetchOnWindowFocus: true, // 👈 only for this query

    staleTime: 1000 * 60 * 5,
  });

export const useGetWalletTransactionById = (transactionId) => {
  return useQuery({
    queryKey: ["customerWalletById"],
    queryFn: async () => {
      const res = await axiosPrivate.get(`customers/wallet-transactions/${transactionId}`);
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}

export const useGetWalletTransactions = ({
  page = 1,
  items_per_page = 10,
  start_date = null,
  end_date = null,
  transaction_type = null,
  wallet_number_or_uuid = '',
  enabled = false
} = {}) => {

  const params = {
    page,
    items_per_page,
    start_date,
    end_date,
    transaction_type,
    wallet_number_or_uuid
  };

  return useQuery({
    queryKey: ["walletTransactions", params],
    queryFn: async () => {
      const res = await axiosPrivate.get(
        `customers/wallet-transactions`,
        { params }
      );
      return res.data;
    },
    enabled,
    staleTime: 0,
    refetchOnMount: true,
  });
};
